import ParameterListController from './parameterListController';


const ParameterListComponent = {
    template: require('./parameterListView.html'),
    controller: ParameterListController,
};

export default ParameterListComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/parametersList/parameterListComponent.js